import React, { Component } from "react";
import axios from "axios";
import { TableCell, TableContainer, TableRow, Paper } from "@mui/material";

import { displayStoredDate, formatAmount } from "../../../helper";
import JobForm from "../../../Components/JobForm";
import PhoneClinicGrid from "../../../Components/PhoneClinicGrid";
import RowActions from "../../../Components/PhoneClinicGrid/RowActions";
import StatusChip from "../shared/StatusChip";


function isJson(string) {
    try {
        JSON.parse(string); // Attempt to parse the string
        return true; // If successful, it's valid JSON
    } catch (e) {
        return false; // If an error occurs, it's not valid JSON
    }
}

const jobRights = {
    "Available": "Available",
    "Finish": "Completed",
    "In Process": "In Process",
    "Completed": "Sale",
    "BER": "Sale",
    "Request": "Available",
    "Refund": "Refund"
};

const chipStatus = {
    "Available": "info",
    "Finish": "success",
    "In Process": "warning",
    "Completed": "neutral",
    "BER": "error",
    "Request": "info",
}

class ShopJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CompletedList: [],
            filteredListData: {},
            openModal: false,
            eligibleFor: ''
        }
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     this.getShopCompRequest()
    // }

    async getShopCompRequest(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_SHOP: localStorage.getItem("PC_GRP_ATT"),
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };

        await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getShopRequest.php`, formData).then((response) => {
            let repairData = [];
            if (response.data.success === 1) {
                let myRecord = []
                let JobRecord = response.data.data
                for (let i = 0; i < JobRecord.length; i++) {
                    const myEle = JobRecord[i]
                    myEle.PC_REP_BRAND = isJson(myEle.PC_REP_BRAND) ? JSON.parse(myEle.PC_REP_BRAND) : myEle.PC_REP_BRAND;
                    myEle.PC_REP_MODEL = isJson(myEle.PC_REP_MODEL) ? JSON.parse(myEle.PC_REP_MODEL) : myEle.PC_REP_MODEL;
                    myEle.PC_REP_LIST = isJson(myEle.PC_REP_LIST) ? JSON.parse(myEle.PC_REP_LIST) : myEle.PC_REP_LIST;
                    myEle.PC_REP_TYPE = isJson(myEle.PC_REP_TYPE) ? JSON.parse(myEle.PC_REP_TYPE) : myEle.PC_REP_TYPE;
                    myEle.PC_REP_NOTES = isJson(myEle.PC_REP_NOTES) ? JSON.parse(myEle.PC_REP_NOTES) : myEle.PC_REP_NOTES;
                    myRecord.push(myEle)
                }
                repairData = myRecord
                pagination.totalItems = parseInt(response.data.Page_count[0]['TOTAL_PAGE_COUNT'])
                pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
                this.gridRef.current?.setPaginationData(pagination)
            }
            this.setState({ CompletedList: repairData })
        }).catch((error) => {
            this.setState({ CompletedList: [] })
        }).finally(() => {
            this.props.toggleLoader(false)
        })
    }


    handleOpenForm() {
        this.setState({
            eligibleFor: "Shop Request",
            filteredListData: {},
            openModal: true
        })
    }

    handleClose() {
        this.getShopCompRequest()
        this.setState({ openModal: false, filteredListData: {} })
    }

    handleEdit(historyRow) {
        let filteredListData = historyRow
        this.setState({
            eligibleFor: jobRights[historyRow.PC_REP_STATUS],
            filteredListData,
            openModal: true
        })
    }


    render() {
        return (
            <div>
                <PhoneClinicGrid
                    ref={this.gridRef}
                    title="REPAIR JOB"
                    buttonLabel="CREATE Request"
                    onClickButton={this.handleOpenForm.bind(this)}
                    getData={this.getShopCompRequest.bind(this)}
                    isEditable={true}
                    tableHeadData={[
                        { label: "DATE", isHidden: false },
                        { label: "BARCODE", isHidden: false },
                        { label: "CUSTOMER", isHidden: false },
                        { label: "DEVICE", isHidden: false },
                        { label: "IMEI / SERIAL NO", isHidden: false },
                        { label: "STATUS", isHidden: false },
                        { label: "TOTAL PRICE", isHidden: false, align: 'right' },
                    ]}
                >
                    {/* One row per record (flattened 2026-10-22). Labels follow the sale/purchase standard (DEVICE,
                        TOTAL PRICE); BARCODE and IMEI / SERIAL NO stay because a repair job is found by them. */}
                    {this.state.CompletedList.map((row, idx) => (
                        <TableRow key={idx}>
                            <TableCell>{displayStoredDate(row.PC_REP_CREATED_DATE)}</TableCell>
                            <TableCell>{row.PC_REP_BARCODE}</TableCell>
                            <TableCell>{row.PC_CUST_FR_NAME + ' ' + row.PC_CUST_LT_NAME || 'N/A'}</TableCell>
                            <TableCell>{row.PC_REP_BRAND.value || 'N/A'}</TableCell>
                            <TableCell>{row.PC_REP_IMSR || 'N/A'}</TableCell>
                            <TableCell><StatusChip label={row.PC_REP_STATUS} type={chipStatus[row.PC_REP_STATUS]} /></TableCell>
                            <TableCell align="right"><strong>£ {formatAmount(row.PC_REP_TOTAL_COST)}</strong></TableCell>
                            <TableCell align='center'>
                                <RowActions actions={[
                                    { type: 'edit', onClick: this.handleEdit.bind(this, row) },
                                ]} />
                            </TableCell>
                        </TableRow>
                    ))}
                </PhoneClinicGrid>
                <JobForm
                    openModal={this.state.openModal}
                    closeModal={this.handleClose.bind(this)}
                    eligibleFor={this.state.eligibleFor}
                    jobData={this.state.filteredListData}
                />
            </div>
        );
    }
}

export default ShopJob;